import React from "react";
import { useAuth } from "../../lib/auth";
import { useNavigate, Link } from "react-router-dom";
import { LogOut, User } from "lucide-react";
import { PublicFeedTab } from "./WeddingPartyPages";
import { ChangePasswordCard } from "../../components/ChangePasswordCard";
import { NotifyPrefsCard } from "../../components/NotifyPrefsCard";

export default function SettingsPage() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const isCouple = user.role === "couple" || user.role === "admin";

  return (
    <div data-testid="settings-page" className="max-w-2xl space-y-6">
      <NotifyPrefsCard />
      <div>
        <p className="font-script text-[var(--gold)] text-3xl">Account</p>
        <h1 className="font-serif font-light text-4xl">Settings</h1>
      </div>

      <div className="bg-white border border-[var(--line)] rounded-2xl p-6 md:p-8 space-y-4">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-[var(--bg-warm)] flex items-center justify-center">
            <User className="w-6 h-6 text-[var(--gold)]" />
          </div>
          <div>
            <p className="font-serif text-2xl">{user.name}</p>
            <p className="text-sm text-[var(--muted)]">{user.email}</p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 pt-4 border-t border-[var(--line)]">
          <div>
            <p className="text-[11px] uppercase tracking-[0.16em] text-[var(--muted)]">Plan</p>
            <p className="font-serif text-xl capitalize">{user.plan}</p>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.16em] text-[var(--muted)]">Role</p>
            <p className="font-serif text-xl capitalize">{user.role}</p>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.16em] text-[var(--muted)]">Sign-in method</p>
            <p className="font-serif text-xl capitalize">{user.auth_provider}</p>
          </div>
        </div>
      </div>

      {user.auth_provider !== "google" && <ChangePasswordCard />}

      {isCouple && <PublicFeedTab />}

      <div className="flex gap-3 flex-wrap">
        {user.role === "admin" && (
          <Link to="/admin" data-testid="settings-admin-link" className="btn-gold">
            Open Admin Console
          </Link>
        )}
        {(user.role === "planner" || user.role === "admin") && (
          <Link to="/planner" data-testid="settings-planner-link" className="btn-outline-gold">
            Planner Console
          </Link>
        )}
        <button onClick={async () => { await logout(); nav("/"); }} data-testid="settings-logout" className="btn-outline-gold"><LogOut className="w-4 h-4" /> Log Out</button>
      </div>
    </div>
  );
}
